import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { catchError, finalize } from 'rxjs/operators';
import { enum_ErrorMessages } from '../_enums/errorMessage.enum';
import { of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalService } from './global.service';

@Injectable()
export class LoginService {

    private headers: HttpHeaders;

    public isLoggingIn: boolean = false;

    constructor(private httpClient: HttpClient, private globalService: GlobalService, private router: Router) {
    }

    private setHeaders(method: string, url: string) {
        console.debug('LoginService().setHeaders()');

        if ((environment.calculator.apiKey == null || environment.calculator.apiKey === undefined) || (environment.calculator.clientId == null || environment.calculator.clientId === undefined)) {
            return;
        }

        let tMethod = method;
        let tDateStamp = new Date();
        let tClientApiKey = environment.calculator.apiKey;
        let tUrl = url;

        let tContentType = (tMethod === 'GET') ? '' : 'application/json;charset=UTF-8';
        let ct = tMethod + tUrl + tContentType + tDateStamp.toUTCString().replace('UTC', 'GMT');
        let ctSHA256 = CryptoJS.HmacSHA256(ct, tClientApiKey);
        let ctBase64 = CryptoJS.enc.Base64.stringify(ctSHA256);

        this.headers = new HttpHeaders({
            'X-TW-API-CLIENTID': environment.calculator.clientId,
            'X-TW-DATE': tDateStamp.toUTCString().replace('UTC', 'GMT'),
            'X-TW-SIGNATURE': ctBase64,
            'Content-Type': tContentType
        });
    }


    login(data: any) {
        console.debug('LoginService.login()');
        let tUrl = environment.urls.base + environment.urls.login;
        this.setHeaders('POST', tUrl);

        this.isLoggingIn = true;

        return this.httpClient.post(tUrl, data, { headers: this.headers, observe: 'response' })
            .pipe(catchError(this.handleError))
            .pipe(finalize(() => {
                this.isLoggingIn = false;
                console.debug('LoginService().login() --> finalize');
            }));
    }

    acknowledgeData(member: any) {
        this._acknowledgeData(member).subscribe(
            (response: any) => {
                if (response.body) {
                    console.debug('SUCCESS acknowledgeData(member: any)', response);
                }
            },
            (error: any) => {
                console.debug('ERROR acknowledgeData(member: any)', error);
            }
        );
    }

    private _acknowledgeData(member: any) {
        console.debug('LoginService._invokeAcknowledgeData()');
        let tUrl = environment.urls.base + environment.urls.init;
        this.setHeaders('POST', tUrl);

        let data = {
            "empId": member.memberNo,
            "acknowledgedData": member.acknowledgedData
        };

        return this.httpClient.post(tUrl, data, { headers: this.headers, observe: 'response' })
            .pipe(catchError(this.handleError))
            .pipe(finalize(() => {
                console.debug('LoginService()._invokeAcknowledgeData() --> finalize');
            }));
    }

    logout(member: any) {
        this._logout(member).subscribe(
            (response: any) => {
                if (response.body) {
                    console.debug('SUCCESS logout(member: any)', response);
                }
            },
            (error: any) => {
                console.debug('ERROR logout(member: any)', error);
            }
        );
    }

    private _logout(member: any) {
        console.debug('LoginService.logout()');
        let tUrl = environment.urls.base + environment.urls.logout;
        this.setHeaders('POST', tUrl);

        let data = null;

        // let data = {
        //     "empId": member.memberNo,
        //     "acknowledgedData": member.acknowledgedData
        // };

        this.isLoggingIn = false;

        return this.httpClient.post(tUrl, data, { headers: this.headers, observe: 'response' })
            .pipe(catchError(this.handleError))
            .pipe(finalize(() => {
                this.isLoggingIn = false;
                console.debug('LoginService()._logout() --> finalize');
            }));
    }

    resetPassword(data: any) {
        console.debug('LoginService.resetPassword()');
        let tUrl = environment.urls.resetPassword;
        this.setHeaders('POST', tUrl);

        return this.httpClient.post(tUrl, data, { headers: this.headers, observe: 'response' })
            .pipe(catchError(this.handleError))
            .pipe(finalize(() => {
                console.debug('LoginService.resetPassword() --> finalize');
            }));
    }

    handleError(error: HttpErrorResponse) {

        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }

        switch (error.status) {
            case 403:
                return of({ error: enum_ErrorMessages.ERRORMESSAGE_403, errorMessage: error });
            case 404:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_404);
            case 500:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_500);
            default:
                return throwError(`${error.status} - ${error.error}`);
        }
    }
}
